window.Webflow ||= [];
window.Webflow.push(() => {
  initializeForm();
  updateQuestions();

  // Add change event listener to radio buttons to update questions when an answer is selected
  document.querySelectorAll('input[type="radio"]').forEach((radioButton) => {
    radioButton.addEventListener('change', () => {
      updateQuestions(); // Re-evaluate which question should be highlighted
    });
  });
});

function updateQuestions(): void {
  const elements: NodeListOf<HTMLElement> = document.querySelectorAll('[kw-tpa-question]');
  let firstUnansweredFound: boolean = false;
  let nextUnansweredElement: HTMLElement | null = null;
  let nextUnansweredIndex: number = -1;

  elements.forEach((element: HTMLElement, index: number) => {
    const radioButtons: NodeListOf<HTMLInputElement> =
      element.querySelectorAll('input[type="radio"]');
    let answered: boolean = Array.from(radioButtons).some((radio) => radio.checked);

    element.style.opacity = '0.2';

    if (!answered && !firstUnansweredFound) {
      // This is the first unanswered question, highlight it
      element.style.opacity = '1';
      firstUnansweredFound = true;
      nextUnansweredIndex = index;

      nextUnansweredElement = element;
    }
    console.log(element);
  });

  // If there's a next unanswered question, scroll to it
  if (nextUnansweredElement && nextUnansweredIndex > 0) {
    (nextUnansweredElement as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function initializeForm(): void {
  const elements: NodeListOf<HTMLElement> = document.querySelectorAll('[kw-tpa-question]');
  const form: HTMLFormElement | null = document.querySelector('[kw-tpa-form]');

  if (form) {
    form.onsubmit = (event) => {
      event.preventDefault();
      event.stopPropagation();

      // Query all radio buttons within the form
      const radioButtons: NodeListOf<HTMLInputElement> = form.querySelectorAll(
        'input[type="radio"]:checked'
      );

      onSubmitForm(radioButtons);
    };
  }

  elements.forEach((element) => {
    const identifier: string = element.getAttribute('kw-tpa-question') ?? '';
    const radioButtons: NodeListOf<HTMLInputElement> =
      element.querySelectorAll('input[type="radio"]');

    radioButtons.forEach((radioButton) => {
      radioButton.setAttribute('data-name', identifier);
      radioButton.setAttribute('name', identifier);
    });
  });
}

function onSubmitForm(radioButtons: NodeListOf<HTMLInputElement>) {
  const categorizedAnswers: { [key: string]: number[] } = {};

  radioButtons.forEach((radio: HTMLInputElement) => {
    const name: string | null = radio.getAttribute('data-name');
    const answerValue: number = parseInt(radio.value);

    if (name) {
      const identifier = name.slice(0, -1); // Get the identifier (e.g., 'S', 'P', 'Re')
      const index = parseInt(name.slice(-1), 10); // Get the numerical part

      if (!categorizedAnswers[identifier]) {
        categorizedAnswers[identifier] = [];
      }

      categorizedAnswers[identifier][index - 1] = answerValue; // Subtract 1 to account for array indexing starting at 0
    }
  });

  const resultSet = calculateScore(categorizedAnswers);

  console.log('Storing result locally .... ', resultSet);
  window.localStorage.setItem('latestResult', JSON.stringify(resultSet));
  window.location.href = 'https://smart-leadership-test.webflow.io/tpa---result';
}

//TODO: Fix this mess
function calculateScore(categorizedAnswers: { [key: string]: number[] }): {
  [key: string]: number;
} {
  const phZ = categorizedAnswers['Z'] || [];
  const phR = categorizedAnswers['R'] || [];
  const phP = categorizedAnswers['P'] || [];
  const phS = categorizedAnswers['S'] || [];
  const phV = categorizedAnswers['V'] || [];
  const phW = categorizedAnswers['W'] || [];
  const phSe = categorizedAnswers['Se'] || [];
  const phSz = categorizedAnswers['Sz'] || [];
  const phRe = categorizedAnswers['Re'] || [];

  const score: any = {
    score1: {},
    score2: {},
    score3: {},
    score3_ex: {},
    score3_enh: {},
    score4: {},
    score5: {},
    score6: {},
  };

  score.score1.leistung = _sum(phZ) + _sum(phR) + _sum(phP);
  score.score1.sozial = _sum(phS) + _sum(phV) + _sum(phW);
  score.score1.entwicklung = _sum(phSe) + _sum(phSz) + _sum(phRe);
  score.score1.cnt = 189;

  score.score2.ziele = _sum(phZ);
  score.score2.rolle = _sum(phR);
  score.score2.prozesse = _sum(phP);
  score.score2.sinn = _sum(phS);
  score.score2.vertrauen = _sum(phV);
  score.score2.werte = _sum(phW);
  score.score2.sensing = _sum(phSe);
  score.score2.seizing = _sum(phSz);
  score.score2.reconfiguring = _sum(phRe);
  score.score2.cnt = 63;

  score.score3.wissen =
    _partialSum(0, phZ) +
    _partialSum(0, phR) +
    _partialSum(0, phP) +
    _partialSum(0, phSe) +
    _partialSum(0, phSz) +
    _partialSum(0, phRe);
  score.score3.koennen =
    _partialSum(3, phZ) +
    _partialSum(3, phR) +
    _partialSum(3, phP) +
    _partialSum(3, phSe) +
    _partialSum(3, phSz) +
    _partialSum(3, phRe);
  score.score3.wollen =
    _partialSum(6, phZ) +
    _partialSum(6, phR) +
    _partialSum(6, phP) +
    _partialSum(6, phSe) +
    _partialSum(6, phSz) +
    _partialSum(6, phRe);
  score.score3.cnt = 126;

  score.score3_ex.wissen = _partialSum(0, phZ) + _partialSum(0, phR) + _partialSum(0, phP);
  score.score3_ex.koennen = _partialSum(3, phZ) + _partialSum(3, phR) + _partialSum(3, phP);
  score.score3_ex.wollen = _partialSum(6, phZ) + _partialSum(6, phR) + _partialSum(6, phP);
  score.score3_ex.cnt = 63;

  score.score3_enh.wissen = _partialSum(0, phSe) + _partialSum(0, phSz) + _partialSum(0, phRe);
  score.score3_enh.koennen = _partialSum(3, phSe) + _partialSum(3, phSz) + _partialSum(3, phRe);
  score.score3_enh.wollen = _partialSum(6, phSe) + _partialSum(6, phSz) + _partialSum(6, phRe);
  score.score3_enh.cnt = 63;

  score.score4.wiZi = _partialSum(0, phZ);
  score.score4.wiRo = _partialSum(0, phR);
  score.score4.wiPr = _partialSum(0, phP);
  score.score4.koZi = _partialSum(3, phZ);
  score.score4.koRo = _partialSum(3, phR);
  score.score4.koPr = _partialSum(3, phP);
  score.score4.woZi = _partialSum(6, phZ);
  score.score4.woRo = _partialSum(6, phR);
  score.score4.woPr = _partialSum(6, phP);

  score.score4.wiSe = _partialSum(0, phSe);
  score.score4.wiSz = _partialSum(0, phSz);
  score.score4.wiRe = _partialSum(0, phRe);
  score.score4.koSe = _partialSum(3, phSe);
  score.score4.koSz = _partialSum(3, phSz);
  score.score4.koRe = _partialSum(3, phRe);
  score.score4.woSe = _partialSum(6, phSe);
  score.score4.woSz = _partialSum(6, phSz);
  score.score4.woRe = _partialSum(6, phRe);
  score.score4.cnt = 21;

  score.score4.wiZi = _partialSum(0, phZ);
  score.score4.wiRo = _partialSum(0, phR);
  score.score4.wiPr = _partialSum(0, phP);
  score.score4.koZi = _partialSum(3, phZ);
  score.score4.koRo = _partialSum(3, phR);
  score.score4.koPr = _partialSum(3, phP);
  score.score4.woZi = _partialSum(6, phZ);
  score.score4.woRo = _partialSum(6, phR);
  score.score4.woPr = _partialSum(6, phP);

  score.score4.wiSe = _partialSum(0, phSe);
  score.score4.wiSz = _partialSum(0, phSz);
  score.score4.wiRe = _partialSum(0, phRe);
  score.score4.koSe = _partialSum(3, phSe);
  score.score4.koSz = _partialSum(3, phSz);
  score.score4.koRe = _partialSum(3, phRe);
  score.score4.woSe = _partialSum(6, phSe);
  score.score4.woSz = _partialSum(6, phSz);
  score.score4.woRe = _partialSum(6, phRe);
  score.score4.cnt = 21;

  score.score5.individuum = _partialSum(0, phS) + _partialSum(0, phV) + _partialSum(0, phW);
  score.score5.team = _partialSum(3, phS) + _partialSum(3, phV) + _partialSum(3, phW);
  score.score5.organisation = _partialSum(6, phS) + _partialSum(6, phV) + _partialSum(6, phW);
  score.score5.cnt = 63;

  score.score6.inSi = _partialSum(0, phS);
  score.score6.inVe = _partialSum(0, phV);
  score.score6.inWe = _partialSum(0, phW);
  score.score6.teSi = _partialSum(3, phS);
  score.score6.teVe = _partialSum(3, phV);
  score.score6.teWe = _partialSum(3, phW);
  score.score6.orSi = _partialSum(6, phS);
  score.score6.orVe = _partialSum(6, phV);
  score.score6.orWe = _partialSum(6, phW);
  score.score6.cnt = 27;

  const dataMap: any = {
    'Leistungsdimension (Execution)': score.score1.leistung / score.score1.cnt,
    'Soziale Dimension (Engagement)': score.score1.sozial / score.score1.cnt,
    'Entwicklungsdimension (Enhancement)': score.score1.entwicklung / score.score1.cnt,
    Ziele: score.score2.ziele / score.score2.cnt,
    Rollen: score.score2.rolle / score.score2.cnt,
    Prozesse: score.score2.prozesse / score.score2.cnt,
    Sinn: score.score2.sinn / score.score2.cnt,
    Vertrauen: score.score2.vertrauen / score.score2.cnt,
    Werte: score.score2.werte / score.score2.cnt,
    Sensing: score.score2.sensing / score.score2.cnt,
    Seizing: score.score2.seizing / score.score2.cnt,
    Reconfiguring: score.score2.reconfiguring / score.score2.cnt,
    'Wissen der Teammitglieder': score.score3.wissen / score.score3.cnt,
    'Können der Teammitglieder': score.score3.koennen / score.score3.cnt,
    'Wollen der Teammitglieder': score.score3.wollen / score.score3.cnt,
    'Exe: Wissen der Teammitglieder': score.score3_ex.wissen / score.score3_ex.cnt,
    'Exe: Können der Teammitglieder': score.score3_ex.koennen / score.score3_ex.cnt,
    'Exe: Wollen der Teammitglieder': score.score3_ex.wollen / score.score3_ex.cnt,
    'Enh: Wissen der Teammitglieder': score.score3_enh.wissen / score.score3_enh.cnt,
    'Enh: Können der Teammitglieder': score.score3_enh.koennen / score.score3_enh.cnt,
    'Enh: Wollen der Teammitglieder': score.score3_enh.wollen / score.score3_enh.cnt,

    'Wissen: Ziele': score.score4.wiZi / score.score4.cnt,
    'Wissen: Rollen': score.score4.wiRo / score.score4.cnt,
    'Wissen: Prozesse (Spielregeln)': score.score4.wiPr / score.score4.cnt,
    'Können: Ziele': score.score4.koZi / score.score4.cnt,
    'Können: Rollen': score.score4.koRo / score.score4.cnt,
    'Können: Prozesse (Spielregeln)': score.score4.koPr / score.score4.cnt,
    'Wollen: Ziele': score.score4.woZi / score.score4.cnt,
    'Wollen: Rollen': score.score4.woRo / score.score4.cnt,
    'Wollen: Prozesse (Spielregeln)': score.score4.woPr / score.score4.cnt,
    'Wissen: Sensing': score.score4.wiSe / score.score4.cnt,
    'Wissen: Seizing': score.score4.wiSz / score.score4.cnt,
    'Wissen: Reconfiguring': score.score4.wiRe / score.score4.cnt,
    'Können: Sensing': score.score4.koSe / score.score4.cnt,
    'Können: Seizing': score.score4.koSz / score.score4.cnt,
    'Können: Reconfiguring': score.score4.koRe / score.score4.cnt,
    'Wollen: Sensing': score.score4.woSe / score.score4.cnt,
    'Wollen: Seizing': score.score4.woSz / score.score4.cnt,
    'Wollen: Reconfiguring': score.score4.woRe / score.score4.cnt,
    Individuum: score.score5.individuum / score.score5.cnt,
    Team: score.score5.team / score.score5.cnt,
    Organisation: score.score5.organisation / score.score5.cnt,
    'Individuum: Sinn': score.score6.inSi / score.score6.cnt,
    'Individuum: Vertrauen': score.score6.inVe / score.score6.cnt,
    'Individuum: Werte': score.score6.inWe / score.score6.cnt,
    'Team: Sinn': score.score6.teSi / score.score6.cnt,
    'Team: Vertrauen': score.score6.teVe / score.score6.cnt,
    'Team: Werte': score.score6.teWe / score.score6.cnt,
    'ORG: Sinn': score.score6.orSi / score.score6.cnt,
    'ORG: Vertrauen': score.score6.orVe / score.score6.cnt,
    'ORG: Werte': score.score6.orWe / score.score6.cnt,
    Zeitstempel: new Date().toISOString(),
    'E-Mail-Adresse': 'todo',
  };
  dataMap['Integrationsstärke deines Teams'] =
    (dataMap['Individuum'] + dataMap['Team'] + dataMap['Organisation']) / 3;
  dataMap['Umsatzstärke deines Teams'] =
    (dataMap['Wissen der Teammitglieder'] +
      dataMap['Können der Teammitglieder'] +
      dataMap['Wollen der Teammitglieder']) /
    3;
  dataMap['Zukunftsstärke deines Teams'] =
    (dataMap['Wissen: Sensing'] +
      dataMap['Wissen: Seizing'] +
      dataMap['Wissen: Reconfiguring'] +
      dataMap['Können: Sensing'] +
      dataMap['Können: Reconfiguring'] +
      dataMap['Können: Seizing'] +
      dataMap['Wollen: Sensing'] +
      dataMap['Wollen: Seizing'] +
      dataMap['Wollen: Reconfiguring']) /
    9;

  return dataMap;
}

function _sum(arr: number[]): number {
  return arr.reduce(function (a: number, b: number) {
    return a + b;
  });
}
function _partialSum(offset: number, arr: number[]): number {
  return arr[offset] + arr[offset + 1] + arr[offset + 2];
}
